import {
    fetch
} from 'FETCH';

export function getVerifyImageCode({token, act_uuid}) {
    return fetch.post('api/v1/activity/actShare', {
        act_uuid,
        token
    });
}

export function getWxAuth({code, type}) {
    return fetch.post('api/v1/wechat/auth', {
        code,
        type
    });
}

export function getActClick({share_code, wxCode}) {
    return fetch.post('api/v1/activity/actClick', {
        share_code,
        wxCode
    });
}

export function sendEquity({share_code, token}) {
    return fetch.post('api/v1/activity/sendEquity', {
        share_code,
        token
    });
}

export function getRecordList(param) {
    return fetch.post('api/v1/activity/getRecordList', {
        page: 1,
        pageSize: 20,
        token: param.token
    });
}

export function getCode(param) {
    return fetch.post('api/v1/common/sendCode', {
        mobile: param.mobile
    });
}

export function actRegister({
    wxCode,
    mobile,
    share_code,
    code
}) {
    return fetch.post('api/v1/activity/actRegister', {
        wxCode,
        mobile,
        share_code,
        code
    });
}

export function actClickList({
    share_code,
    wxCode
}) {
    return fetch.post('api/v1/activity/actClickList', {
        share_code,
        wxCode
    });
}